import React from 'react';

type CardProps = {
  children: React.ReactNode;
  className?: string;
  animationDelay?: number;
};

export function Card({ children, className = '', animationDelay = 0 }: CardProps) {
  return (
    <div
      className={`animate-fade-in-up rounded-2xl border border-stone-200/80 bg-white p-6 opacity-0 shadow-sm transition-shadow hover:shadow-md dark:border-stone-600 dark:bg-stone-800 ${className}`}
      style={{ animationDelay: `${animationDelay}ms` }}
    >
      {children}
    </div>
  );
}
